export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';

export function loginRequest(form,pref) {
    return {
        type: LOGIN_REQUEST,
        payload: {form,pref},
    };
}

export const LOGIN_ACTION = 'LOGIN_ACTION';

export function loginAction(token) {
    return {
        type: LOGIN_ACTION,
        payload: {token},
    };
}

export const MANAGER_PROFILE_REQUEST = 'MANAGER_PROFILE_REQUEST';
export const MANAGER_PROFILE_SUCCESS = 'MANAGER_PROFILE_SUCCESS';
export const MANAGER_PROFILE_FAIL = 'MANAGER_PROFILE_FAIL';

export function managerProfileRequest({prof,id}) {
    return {
        type:MANAGER_PROFILE_REQUEST,
        payload: {prof,id},
    };
}

export const MANAGER_UPDATE_REQUEST = 'MANAGER_UPDATE_REQUEST';
export const MANAGER_UPDATE_SUCCESS = 'MANAGER_UPDATE_SUCCESS';
export const MANAGER_UPDATE_FAIL = 'MANAGER_UPDATE_FAIL';

export function managerUpdateRequest({form,id}) {
    return {
        type:MANAGER_UPDATE_REQUEST,
        payload: {form,id},
    };
}

export const MANAGER_NOTIFICATION_REQUEST = 'MANAGER_NOTIFICATION_REQUEST';
export const MANAGER_NOTIFICATION_SUCCESS = 'MANAGER_NOTIFICATION_SUCCESS';
export const MANAGER_NOTIFICATION_FAIL = 'MANAGER_NOTIFICATION_FAIL';

export function managerNotificationRequest(fetch) {
    return {
        type:MANAGER_NOTIFICATION_REQUEST,
        payload: {fetch},
    };
}


export const MANAGER_NOTIFY_REQUEST = 'MANAGER_NOTIFY_REQUEST';
export const MANAGER_NOTIFY_SUCCESS = 'MANAGER_NOTIFY_SUCCESS';
export const MANAGER_NOTIFY_FAIL = 'MANAGER_NOTIFY_FAIL';

export function managerNotifyRequest(fetch) {
    return {
        type:MANAGER_NOTIFY_REQUEST,
        payload: {fetch},
    };
}